<template>
    <div class="Select" >
        <el-cascader
        popper-class="flowics"
        v-model="value"
        :options="flowicsSelectList"
        @focus='showFlowicsList'
        @change="handleChange"
        :props="{value:'id',label:'name'}"
        ref="getValue">
         <template slot-scope="{  data }">
          <span >{{ data.name }}</span>
        </template>
        </el-cascader>
    </div>
</template>

<script>
import toTips from '@/assets/js/toTipsObj'
import Outil from '@/assets/js/utils.js'
export default {
  props: {
    // singular的参数
    SingularMessage: {
      type: Object,
      default: () => {}
    },
    // 是否将弹出框插入至 body 元素,在弹出框的定位出现问题时，可将该属性设置为 false
    AppendBody: {
      type: Boolean,
      default: true
    },
    // flowics参数
    selectIdParam: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      //   选中的文件id
      pitchOnFile: '',
      // 加载
      FirstLoading: false,
      // 拥有者Id
      OwnerUserid: '',
      flowicsSelectList: [],
      value: []
    }
  },
  created () {
    this.getFlowicsList()
  },
  mounted () {
    this.value = [this.selectIdParam.sceneId, this.selectIdParam.regionId, this.selectIdParam.id]
  },
  watch: {
    // 'SingularMessage.flowicsToken'(){
    //    this.getFlowicsList ()
    // }
  },
  methods: {
    // 获取Flowics列表
    getFlowicsList () {
      const ProgramId = this.$BehaviorSyns.getProgramId()
      if (!ProgramId) return
      this.axios.post('/gatewayPlayoutUrl/tvu-playout/iframe/info', {
        iframeToken: this.SingularMessage.flowicsToken,
        programId: ProgramId
      }).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (res.data.result) {
            const result = res.data.result
            this.flowicsSelectList = result.map(v => {
              v.list = v.list.map(i => {
                return { children: i.iframeInfoParams, ...i }
              })
              return { ...v, children: v.list }
            })
            // this.flowicsSelectList = result
          }
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.error(errorInfo)
        }
      }).catch(() => {})
    },
    // Flowics选择
    handleChange (value) {
      const data = this.$refs.getValue.getCheckedNodes()[0].data
      const params = { data, value: this.value }
      this.$emit('FlowicsParamSelect', params)
    },
    showFlowicsList () {
      // this.getFlowicsList()
    }
  }
}
</script>
<style scoped lang="less">
  .Select{
    ::v-deep  .el-cascader{
      width: 100%;
    }
    ::v-deep .el-select-dropdown{
      .el-scrollbar__wrap{
        .el-scrollbar__view{
          width: 100%;
        }
      }
    }
  }
</style>
<style  lang="less">
.flowics{
  border: none;
}
</style>
